import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-hot-toast';
import './MealPlanModal.css';

const MealPlanModal = ({ onClose, onSave, menuItem }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [mealType, setMealType] = useState('');
  const [successState, setSuccessState] = useState(null);
  const [savingAction, setSavingAction] = useState(null);
  const navigate = useNavigate();

  const handleSave = async (mode) => {
    if (!mealType) {
      toast.error('Please select a meal type');
      return;
    }

    try {
      setSavingAction(mode);
      const result = await onSave(selectedDate, mealType, {
        addToShoppingList: mode === 'plan-and-list'
      });

      if (result?.success) {
        setSuccessState({
          addedToShoppingList: Boolean(result.addedToShoppingList)
        });
      }
    } finally {
      setSavingAction(null);
    }
  };

  const handleGoToMealPlan = () => {
    navigate('/meal-plan');
    onClose();
  };

  if (successState) {
    return (
      <div className="meal-plan-modal-overlay">
        <div className="meal-plan-modal success">
          <h2>{successState.addedToShoppingList ? 'Added to Plan & Shopping List!' : 'Added to Meal Plan!'}</h2>
          <h3>{menuItem.title}</h3>
          <div className="modal-actions">
            <button className="cancel-btn" onClick={onClose}>OK</button>
            <button className="meal-plan-btn" onClick={handleGoToMealPlan}>
              Go to Meal Plan
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="meal-plan-modal-overlay">
      <div className="meal-plan-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Add to Meal Plan</h2>
        <h3>{menuItem.title}</h3>
        
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <label>Select Date:</label>
            <DatePicker
              selected={selectedDate}
              onChange={date => setSelectedDate(date)}
              minDate={new Date()}
              dateFormat="MMMM d, yyyy"
            />
          </div>
          
          <div className="form-group">
            <label>Meal Type:</label>
            <div className="meal-type-buttons">
              <button
                type="button"
                className={`meal-type-btn ${mealType === 'breakfast' ? 'selected' : ''}`}
                onClick={() => setMealType('breakfast')}
              >
                Breakfast
              </button>
              <button
                type="button"
                className={`meal-type-btn ${mealType === 'lunch' ? 'selected' : ''}`}
                onClick={() => setMealType('lunch')}
              >
                Lunch
              </button>
              <button
                type="button"
                className={`meal-type-btn ${mealType === 'dinner' ? 'selected' : ''}`}
                onClick={() => setMealType('dinner')}
              >
                Dinner
              </button>
            </div>
          </div>
          
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
            <button
              type="button"
              className="save-btn save-btn-secondary"
              onClick={() => handleSave('plan-only')}
              disabled={Boolean(savingAction)}
            >
              {savingAction === 'plan-only' ? 'Adding...' : 'Add to Plan'}
            </button>
            <button
              type="button"
              className="save-btn"
              onClick={() => handleSave('plan-and-list')}
              disabled={Boolean(savingAction)}
            >
              {savingAction === 'plan-and-list' ? 'Adding...' : 'Add to Plan & Shopping List'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MealPlanModal; 